// ===========================================================================
// Clinical Note — Template Confirm (módulo TEMPORAL, ya RETIRADO de prod)
//
// Pantalla de revisión de los templates reales de nota clínica de AMD: un
// tab por template, y dentro de cada uno la nota completa con todos sus campos
// y su distribución por secciones. El catálogo de templates es una COPIA del
// del CDCI (ver templates/index.js) para que la revisión no toque el módulo
// productivo.
//
// La revisión TERMINÓ (2026-09-25): en producción no publica rutas ni ítem de
// sidebar (TEMPLATE_CONFIRM_ENABLED, gate por entorno) — queda solo en dev
// como referencia. Siguiente paso cuando nadie lo use tampoco en dev: borrar
// el módulo y sus entradas de app/routes.js y config/navigationConfig.js.
// ===========================================================================
import React, { lazy } from "react";
import { TEMPLATE_CONFIRM_BASE_PATH, TEMPLATE_CONFIRM_ENABLED } from "./common/constants";

const TemplateConfirmPage = lazy(() => import("./pages/TemplateConfirmPage"));

// El módulo resuelve su propio gating: en producción no publica rutas.
export const clinicalNoteTemplateConfirmRoutes = TEMPLATE_CONFIRM_ENABLED
  ? [{ path: TEMPLATE_CONFIRM_BASE_PATH, element: <TemplateConfirmPage /> }]
  : [];

export { TEMPLATE_CONFIRM_BASE_PATH } from "./common/constants";
